import { React, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Dropdown, Grid, Button, Icon } from 'semantic-ui-react'
import { DebounceInput } from 'react-debounce-input'
import Swal from 'sweetalert2'
import { history } from '../../../redux/store'
import {
  GetUserCustomers,
  GetCustomerDevices,
  GetCustomerDevicesWithSearch,
} from '../../../services/asset/index'
import styles from '../device-info-view/device-view.module.css'
import { setCustomerData } from '../../../redux/actions/deviceData'
import IntelMsg from '../../ItelMsg'
import DevicesTable from './devicesTable'
import generateRows from './generateRows'

const size = 10

const DeviceList = () => {
  const { userEmail } = useSelector((store) => ({
    userEmail: store.auth.userEmail,
  }))
  const productName = localStorage.getItem('product')
  const [devices, setDevices] = useState([])
  const [pagesCount, setPagesCount] = useState(0)
  const [customersList, setCustomersList] = useState([])
  const [customerId, setCustomerId] = useState('')
  const [selectedCustomer, setSelectedCustomer] = useState()
  const [search, setSearch] = useState('')
  const [activePage, setActivePage] = useState(1)
  // const [selectedCustomer, setSelectedCustomer] = useState()
  const dispatch = useDispatch()
  const customerData = []
  useEffect(() => {
    GetUserCustomers(userEmail, 'cold').then((customers) => {
      customers.forEach((customer) => {
        console.log('cust', customer)
        customerData.push({
          text: customer.title,
          value: customer.tbCustomerId,
        })
      })
      setCustomersList(customerData)
      ;(async () => {
        const storageCustomerId = await localStorage.getItem('customer')
        if (!storageCustomerId) return
        dispatch(setCustomerData(storageCustomerId))
        setDevices([])
        setPagesCount(0)
        Swal.showLoading()
        const product = await localStorage.getItem('product')
        const customerDevices = await GetCustomerDevices(
          userEmail,
          product,
          0,
          size,
          storageCustomerId,
        )
        setDevices(generateRows(customerDevices.data))
        setSelectedCustomer(
          customerData.find((e) => e.value === storageCustomerId).value,
        )
        setCustomerId(storageCustomerId)
        setPagesCount(customerDevices['no of pages'])
        Swal.close()
      })()
    })
  }, [])

  const handleChange = async (e, data) => {
    console.log('customerIdddd', data.value)
    dispatch(setCustomerData(data.value))
    setDevices([])
    setPagesCount(0)
    Swal.showLoading()
    const product = await localStorage.getItem('product')
    const customerDevices = await GetCustomerDevices(
      userEmail,
      product,
      0,
      size,
      data.value,
    )
    setDevices(generateRows(customerDevices.data))
    setCustomerId(data.value)
    setSelectedCustomer(
      customersList.find((el) => el.value === data.value).value,
    )
    setPagesCount(customerDevices['no of pages'])
    Swal.close()
    localStorage.setItem('customer', data.value)
  }

  const handleSearch = async (e) => {
    const searchText = e.target.value
    setSearch(searchText)
    if (customerId === '') return
    setDevices([])
    setPagesCount(0)
    Swal.showLoading()
    const product = await localStorage.getItem('product')
    const customerDevices = await GetCustomerDevicesWithSearch(
      userEmail,
      product,
      0,
      size,
      customerId,
      searchText,
    )
    setActivePage(1)
    setDevices(generateRows(customerDevices.data))
    setPagesCount(customerDevices['no of pages'])
    Swal.close()
  }

  return (
    <>
      <Grid columns={3}>
        <Grid.Row>
          <Grid.Column width={2}>
            <b>Select Customer:</b>
          </Grid.Column>
          <Grid.Column>
            <Dropdown
              placeholder="You have to select Customer"
              fluid
              search
              selection
              options={customersList}
              style={{
                marginBottom: '2rem',
                borderColor: '#000',
                borderRadius: '0',
              }}
              value={selectedCustomer || ''}
              onChange={(e, data) => {
                handleChange(e, data)
              }}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>

      <Grid columns={3}>
        <Grid.Row>
          <Grid.Column width={2}>
            <b>Search:</b>
          </Grid.Column>
          <Grid.Column>
            <DebounceInput
              debounceTimeout={400}
              style={{
                width: 347,
                height: 40,
                border: '1px solid',
                outline: 'none',
              }}
              placeholder="Search for a device with name"
              value={search}
              onChange={handleSearch}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>

      <br />

      <div className={styles.container}>
        <IntelMsg id="devicesList" />
      </div>

      <DevicesTable
        devices={devices}
        size={size}
        pagesCount={pagesCount}
        customerId={customerId}
        search={search}
        activePage={activePage}
        setActivePage={setActivePage}
      />
      <div className={styles.actions}>
        <Button
          form="customerSettings"
          type="submit"
          style={{ backgroundColor: '#303d54', color: 'white' }}
          onClick={() => {
            if (productName === 'tank') history.push('/Tank')
            else history.push('/cold')
          }}
        >
          <Icon name="arrow left" />
          <IntelMsg id="back" />
        </Button>
      </div>
    </>
  )
}

export default DeviceList
